// ============================================================================
// home-page-setting-client-mod -- Mod Definition
//
// 站点首页路径设置前端 mod。
// 通过 Admin Slot 注入到管理员中心。
// ============================================================================
import { ADMIN_SLOTS_INTERFACE_TAG } from '@hvsin/admin-contracts';
import { FETCH_SERVICE_INTERFACE_TAG } from '@hvsin/fetch-contracts';
import { HomePageSettingAdminRegistrar } from './home-page-setting-admin-registrar.js';
export const homePageSettingClientMod = {
    name: 'home-page-setting-client',
    modDependencies: ['ui-registry', 'admin-center-client'],
    serviceDefs: [
        {
            serviceTag: 'homePageSettingAdminRegistrar',
            serviceImpl: HomePageSettingAdminRegistrar,
            dependencies: [
                ADMIN_SLOTS_INTERFACE_TAG,
                FETCH_SERVICE_INTERFACE_TAG,
            ],
        },
    ],
};
//# sourceMappingURL=mod.js.map